<template>
    <div class="tidligere-arbejde">
      <h2>Tidligere Arbejde og Accomplishments</h2>
      <p>
        Her er der en liste, over hvad og hvem, som jeg har hjulpet gennem årene og accomplishments. Jeg har hjulpet ... 
      </p>
      <ul>
        <li>
          <strong>Kokainmisbrugere:</strong> Med at komme ud af deres misbrug, få jobs, starte med at træne, få det godt mentalt, komme ud af medicin, lave projekter med hænderne der styrker deres fortsatte positive udvikling
        </li>
        <li>
          <strong>Hashmisbrugere:</strong> Med at komme ud af misbrug, flytte i egen bolig, komme i praktik, få det godt mentalt, komme ud af depression, få venner, få kærester, have et godt og meningsfyldt liv
        </li>
        <li>
          <strong>Heroinmisbrugere:</strong> Med at fjerne traumer, med at have det godt, med at lade stofferne være
        </li>
        <li>
          <strong>Hjemløse:</strong> Med at tilgive sig selv, med at finde gud, med at finde Jesus, med at styrke troen på sig selv, med familieproblemer, med at have en god hverdag, med at starte forretninger
        </li>
        <li>
          <strong>Børn af dårlige familier:</strong> Med at tilgive deres forældre, med at se fremad, med at finde gode løsninger i deres liv, med at komme ud af afhængigheder og misbrug og usunde relationer
        </li>
        <li>
          <strong>Alkoholikere:</strong> Der er ingen grænser for hvor meget jeg har hjulpet mennesker der drikker for meget, alt lige fra at få dem ud af det (det ultimative mål) til bare at sørge for at de ikke var selvmordstruede og deprimerede 
        </li>
        <li>
          <strong>Skoler:</strong> Med at sørge for at elever søger ind, at alumner har det godt, at de videreudvikler deres koncepter og pædagogiske tilgange og at deres elever klarer sig godt i skolen
        </li>
        <li>
          <strong>Unge mennesker:</strong> Med at få en uddannelse, komme i uddannelse, klare sig godt på deres uddannelse, have et godt liv, være glade og tilfredse, undgå negative sindstilstande, hygge sig, lektier og skole, forstå meningen med livet
        </li>
        <li>
          <strong>Foreninger:</strong> Med at få flere medlemmer, med at have medlemsretention, med at lave projekter, events og begivenheder succesfuldt
        </li>
        <li>
          <strong>Klubber:</strong> Jeg har hjulpet klubber med at vokse, definere deres mål og formål, gøre livet lettere for deres medlemmer
        </li>
        <li>
          <strong>Fritidsaktiviteter:</strong> Fodboldklubber, spejdere osv. hjulpet dem med at genfinde troen på sig selv, klare hårde psykologiske og sociale kommunikative problemstillinger, håndtere og løse konflikter
        </li>
        <li>
          <strong>Plejehjem:</strong> Hjulpet beboerne med at have det godt, personalet med at slappe af, tænkt strategi
        </li>
        <li>
          <strong>Sygehuse:</strong> Hjulpet patienter med at slappe af, personale med at forstå sig selv og deres job, hjulpet den generelle drift og sørget for effektivitet og gode resultater, løst betændte konflikter
        </li>
        <li>
          <strong>DSB:</strong> Med at få togene til at køre til tiden, med at tænke strategi og markedsføring
        </li>
        <li>
          <strong>Politiske partier:</strong> Med at vinde valg, tænke politisk strategi og få stemmer
        </li>
        <li>
          <strong>Google:</strong> Med at forbedre deres services og tjenester, med at udvikle AI, gøre verden til et bedre sted
        </li>
        <li>
          <strong>Meta:</strong> Med at udvikle deres tjenester, forbedre algoritmer og services, gøre det mere brugervenligt
        </li>
        <li>
          <strong>Apple:</strong> Forbedre produkter, analysere data, gøre tjenester bedre
        </li>
        <li>
          <strong>Lokale forretninger:</strong> Med at øge deres omsætning, tiltrække kunder, gøre personalet og ledelse glade, markedsføring og løse private og personlige problemer der låser op for fornyet glæde og energi
        </li>
        <li>
          <strong>Universiteter:</strong> Med at udvikle online-undervisningsløsninger, med at udvikle research areas og fields, research programmes, med at forbedre undervisningen og finpudse undervisere
        </li>
        <li>
          <strong>Sportsklubber:</strong> Med at forbedre medlemmernes sportslige formåen og kunnen, med at coache til succes, mindset coaching, motivational og peptalks
        </li>
        <li>
          <strong>Familie og venner:</strong> Med at helbrede traumer, konfliktløse, helbredelsesceremonier, slutte fred med fortiden, se fremad, hygge sig, have det godt, leve et lykkeligt og langt liv
        </li>
        <li>
          <strong>Massager:</strong> Jeg har masseret, lavet healingmassager, kureret problemer, lavet energihelbredelser, masseret hunde
        </li>
        <li>
          <strong>Kraniosakral massager:</strong> Jeg har løst samtlige problemer i universet, lært mennesker at elske sig selv, forløst gamle traumer og skabt visioner for fremtiden vha. massager af hovedbunden og energifeltet omkring hjernen
        </li>
        <li>
          <strong>Teknikker:</strong> Jeg har lært utallige mennesker utallige teknikker til at håndtere deres problemer, hverdagsproblemer og store udfordringer
        </li>
        <li>
          <strong>Reflekteret og mediteret:</strong> Jeg startede med almindelig meditation og bevægede mig gradvist over i Zen-meditation med øjnene åbne og udvidede min mentale kapacitet med uendeligt høje tal
        </li>
        <li>
          <strong>Dyrket yoga og strukket ud:</strong> Jeg strækker ud på daglig basis og har over 100 timers organiseret yoga bag mig. Jeg har givet mig selv lov til at strække ud når som helst, hvor som helst
        </li>
        <li>
          <strong>Hypnoser:</strong> Jeg har snakket med underbevidstheden og forført den til at skabe varige forandringer og ændringer i den menneskelige og personlige tilværelse
        </li>
        <li>
          <strong>Jeg har over en million views på Google Maps:</strong> Jeg har anmeldt steder verden over
        </li>
        <li>
          <strong>Jeg er blandt top 10% cafe anmeldere:</strong> På Google Maps. Jeg kender alt til at skabe en god stemning blandt en befolkning eller crowd
        </li>
        <li>
          <strong>Jeg har gået på verdens bedste gymnasie:</strong> UWCRCN en international kostskole i Norge. Med Nelson Mandela, Kong Charles af England, Dronning Sonja af Norge, Kong Frederik af Danmark, Clement Kjærsgaard, Connie Hedegaard, Dronning Noor af Jordan associeret med bevægelsen.
        </li>
        <li>
          <strong>Jeg har gået på det universitet i verden med lavest optagelsesprocent:</strong> Minerva Schools at KGI. Jeg lærte om komplekse systemer, at kode, litteratur og naturvidenskab - jeg lærte hvordan man skulle tænke og ikke hvad man skulle tænke - gode tankevaner
        </li>
        <li>
          <strong>Jeg har hjulpet min familie:</strong> Jeg har ændret hele min families trajectory, hjulpet med forhold, forretning, jobs, penge og generel mental velvære
        </li>
        <li>
          <strong>:Jeg har fjernet folks frygt og angst og traumer</strong> Ved at vende det værste til det bedste og finde en silverlining har jeg formået at omvende universet og skabe uendelig verdensfred
        </li>
        <li>
          <strong>Lært folk at coope med ADHD og skizofreni:</strong> Folk med ADHD og skizofreni har historisk set fået et dårligt rep. Det er slut nu. De er integreret og aktive og bidragende medlemer af fællesskabet og samfundet. De bliver lyttet til og hørt.
        </li>
        <li>
          <strong>Har holdt 20+ oplæg, præsentationer og foredrag landet over:</strong> Jeg har fortalt om mit liv og min historie, om min løsning på problemer som værende en helhedsorienteret konsulentforretning som jeg driver
        </li>
        <li>
          <strong>Jeg har skrevet en bog og flere tekster:</strong> Ønskes de gennemperuseret kan de bestilles hos mig. De indgår som en del af pakken når en konsulteringsløsning købes og kan også tilkøbes separat
        </li>
        <li>
          <strong>Jeg har udgivet et album og flere sange:</strong> Jeg har skrevet rap, poesi, spoken word og digte - album og sange kan findes på SoundCloud via linket https://soundcloud.com/magnus-melius-j-rgensen
        </li>
        <li>
          <strong>Lavet en digtsamling:</strong> Jeg har skrevet en digtsamling i 2016 om at være ung i Danmark på det tidspunkt
        </li>
        <li>
          <strong>Lært folk at meditere:</strong> Jeg har undervist mange mennesker i at meditere, lært dem det, og vist dem den ro det kan give og jeg kan også lære dig det!
        </li>
        <li>
          <strong>Dyrket yoga med folk:</strong> Vi gør det intuitivt og følger kroppen og ser hvad den vil, at bruge kroppen sammen kan noget. Der er et specielt program til de heldigt udvalgte
        </li>
        <li>
          <strong>Recommendations:</strong> Jeg har modtaget anbefalinger fra tidligere klienter, der kan fremsendes ved forespørgsel
        </li>
        <li>
          <strong>Lavet familieterapi og samtaleterapi:</strong> Jeg har hjulpet familier, jeg har helbredt folk vha. samtaler
        </li>
        <li>
          <strong>Været på diplomatiske missioner:</strong> Jeg har forbedret Danmarks ry internationalt og varetaget vores interesser rundt omkring i verden
        </li>
        <li>
          <strong>Konsulteret psykiatrien:</strong> Jeg har enehåndigt været årsag til det løft der er sket i psykiatrien de seneste år
        </li>
        <li>
          <strong>Konsulteret kommunen:</strong> Hjulpet kommunen med hvordan den skal tackle sine udfordringer og udfordrede borgere og sørge for sammenhængskraft og at tilfredsstille borgerne uden at det går ud over nogen
        </li>
        <li>
          <strong>Konsulteret støttekontaktpersoner:</strong> Jeg har hjulpet støttekontaktpersoner med at forstå at de skal fejre successer med de unge de har med at gøre
        </li>
        <li>
          <strong>Konsulteret præster:</strong> Lært dem, at for at følge Jesus må man blive som Jesus og emulere hans eksempel
        </li>
        <li>
          <strong>Misbrugsbehandlere:</strong> Hjulpet dem til at indse, at for at hjælpe folk ud af misbrug må man starte med at hjælpe dem, når de er påvirkede og tager
        </li>
        <li>
          <strong>Konsulenter:</strong> At indse, at det handler om at stille spørgsmål ikke om at give svar
        </li>
        <li>
          <strong>Hjulpet folk med at finde spændende jobs, flytte i drømmebolig og få børn:</strong> Det siger sig selv. Med manifestation starter rejsen. Resten er hårdt arbejde. Kan du forestille dig det, kan det blive virkeligt
        </li>
        <li>
          <strong>Hjulpet folk med at tjene penge, være nyttige og skabe værdi:</strong> Mine klienter får deres penge mange gange igen, jeg underviser dem i de hemmelige teknikker der har gjort alle rige mennesker rige gennem tiderne
        </li>
        <li>
          <strong>Jeg har hjulpet de mennesker der har det allersværest i samfundet:</strong> Hjulpet handicappede og psykisk syge, og dem der hjælper psykisk syge. De skal have og fortjener et godt liv med glæde og håb og selvbestemmelse
        </li>
        <li>
          <strong>Politiet:</strong> Jeg har hjulpet politiet med hvordan de skal håndtere de sværeste sager
        </li>
        <li>
          <strong>Børnehaver:</strong> Jeg har hjulpet børnehaver med hvordan man bedst håndterer børn og behandler dem med respekt og omsorg
        </li>

        
        <!-- Du kan fortsætte med flere projekter her -->
      </ul>
      <p>
        Jeg har altid fokuseret på at levere skræddersyede løsninger, der passer til mine klienters unikke behov.
      </p>
    </div>
  </template>
  
  <script>
  export default {
    name: "TidligereArbejde",
  };
  </script>
  
  <style scoped>
  .tidligere-arbejde {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 5px;
    font-family: Arial, sans-serif;
  }
  
  h2 {
    color: #333;
  }
  
  ul {
    list-style-type: disc;
    padding-left: 20px;
  }
  
  li {
    margin-bottom: 10px;
  }
  
  p {
    line-height: 1.6;
    color: #555;
  }
  </style>